<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
		<g :style="`fill:${active ? 'white' : globalColors.primary};`">
			<path d="M21.948 3H3.058C1.37 3 0 4.392 0 6.104v13.11c0 1.712 1.37 3.104 3.057 3.104h18.886c1.686 0 3.057-1.392 3.057-3.104V6.109C25.005 4.397 23.634 3 21.948 3zm1.66 16.214c0 .93-.744 1.686-1.66 1.686H3.058c-.916 0-1.661-.756-1.661-1.686V6.109c0-.93.745-1.686 1.66-1.686h18.886c.915 0 1.66.757 1.66 1.686v13.105h.006z"/>
        	<path d="M16.344 11.928l6.14-5.441a.69.69 0 0 0 .052-.98.71.71 0 0 0-.993-.052l-8.466 7.51-1.651-1.458c-.005-.005-.01-.01-.01-.015a1.035 1.035 0 0 0-.115-.098L4.581 5.45a.706.706 0 0 0-.993.056.686.686 0 0 0 .057.98l6.212 5.488-6.186 5.724a.69.69 0 0 0-.03.98.707.707 0 0 0 .992.036l6.279-5.806 1.703 1.504a.706.706 0 0 0 .935-.005l1.75-1.55 6.243 5.862c.136.128.312.19.484.19a.704.704 0 0 0 .509-.216.69.69 0 0 0-.026-.98l-6.166-5.785z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'email-component',
	props: {
		active: {
			default: false,
			type: Boolean,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/email-component.vue